import type { QueryClient } from "@tanstack/react-query";
import { ReportsApi } from "@/openapi/generated";
import { QueryKeys } from "@/lib/types";
import { createAuthenticatedApi } from "@/lib/utils";

const REPORTS_STALE_TIME_MS = 5 * 60 * 1000;

export async function prefetchReportsList(
  queryClient: QueryClient,
  accessToken: string,
) {
  const service = createAuthenticatedApi(ReportsApi, accessToken);

  await queryClient.prefetchQuery({
    queryKey: [QueryKeys.Reports],
    queryFn: () => service.apiReportsListGet(),
    staleTime: REPORTS_STALE_TIME_MS,
  });

  return queryClient;
}
